import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography
} from "@mui/material";
import { useTranslation } from "react-i18next";

const ConsentDialog = ({ open = false, setOpen }) => {

    const { t } = useTranslation('common');

    const activeCompanyName = localStorage.getItem("activeOfficeName");
    
    const handleClose = (event, reason) => {
        // Prevent closing when clicking the backdrop or pressing Escape
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
        return;
        }
        setOpen(false);
    };

    
    const onConfirm = () => {
        setOpen(false);
    }

    return (
        <Dialog open={open} onClose={handleClose}>
                <DialogTitle>
                    Consent Agreement
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body1">{t('guests.messages.consent', {name: activeCompanyName})}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                    onClick={onConfirm}
                    color="primary"
                    >
                    I Agree
                    </Button>
                </DialogActions>
        </Dialog>
  );
};

export default ConsentDialog;